const HR_ERRORS = {
  DEFAULT_VISIBLE_TEXT: '--',
  NOT_AVAILABLE: 'not available yet',
  NOT_EXISTS: 'not exist in HRA',
  HR_SERVER_RESPONSE_ERRROR_OFFLINE: 404
};

const CODE_ERRORS = {
  UNAUTHORIZED : 401,
  FORBIDDEN : 403,
  NOT_FOUND : 404,
  INTERNAL_SERVER_ERROR : 500,
  ANGULARJS_SERVER_DOWN_OR_NO_INTERNET: -1,
};

const TIMEOUT = 'Connection timeout error';

export {
  HR_ERRORS,
  CODE_ERRORS,
  TIMEOUT
};



// WEBPACK FOOTER //
// ./client/app/common/domain/constants.errors.js